<template>
  <div>
    <div class="listNav">
      <div class="main">
        <span>您的位置：</span>
        <span>首页</span>
        <span>></span>
        <span>个人中心</span>
        <span>></span>
        <span>我的教学</span>
      </div>
    </div>
    <div class="bg">
      <div style="height: 20px"></div>
      <div class="main">
        <div class="maincontent">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="touxiang">
                  <div class="imgContent">
                    <img :src="picUrl" alt />
                  </div>
                  <div class="teaNickname">{{ nickname }}</div>
                </div>
                <div class="separate"></div>
                <!-- <router-link class="navTrain" to="/center" tag="div">我的课</router-link> -->
                <router-link class="navTrain" to="/center/self" tag="div"
                  >个人资料</router-link
                >
                <router-link class="navTrain" to="/center/study" tag="div"
                  >我的学习</router-link
                >
                <router-link class="navTrain" to="/center/collection" tag="div"
                  >收藏中心</router-link
                >
                <!-- <router-link class="navTrain" to="/space/folder" tag="div">我的书签</router-link> -->
                <router-link class="navTrain" to="/center/publish" tag="div"
                  >我要出版</router-link
                >
                <!-- <router-link class="navTrain" to="/space/folder" tag="div">通知</router-link> -->
              </div>
            </el-col>
            <el-col :span="18">
              <div
                class="grid-content bg-purple"
                style="background-color: #fff"
              >
                <router-view></router-view>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      picUrl: window.localStorage.getItem('picUrl'),
      nickname: window.localStorage.getItem('nickname'),
    }
  },
}
</script>
<style lang="scss" scoped>
.listNav {
  width: 100%;
  height: 42px;
  background: rgba(237, 234, 231, 1);
  span {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 42px;
    margin-right: 5px;
  }
  :nth-child(6) {
    color: #b50e05;
  }
}
.bg {
  background-image: url('../../assets/img/matbg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .main {
    // background-color: #fff;
  }
}
.maincontent {
}
.touxiang {
  overflow: hidden;
  height: 178px;
  text-align: center;
  background-color: #fff;
  .imgContent {
    margin: 0 auto;
    height: 80px;
    width: 80px;

    margin-top: 30px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .teaNickname {
    margin-top: 15px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 14px;
  }
}
.separate {
  height: 10px;
  background-color: rgba(248, 248, 248, 1);
}
.navTrain {
  // width: 100%;
  font-size: 12px;
  height: 42px;
  background: #fff;
  line-height: 42px;
  color: rgba(102, 102, 102, 1);
  padding-left: 20px;
  border-bottom: 1px solid rgba(230, 230, 230, 0.3);
  &:hover {
    font-size: 14px;
    background: rgba(181, 14, 5, 1);
    color: rgba(255, 255, 255, 1);
  }
}
.router-link-active {
  font-size: 14px;
  background: rgba(181, 14, 5, 1);
  color: rgba(255, 255, 255, 1);
}
</style>